import { render, staticRenderFns } from "./HomeElections2023.vue?vue&type=template&id=393e9c5e&"
import script from "./HomeElections2023.vue?vue&type=script&lang=js&"
export * from "./HomeElections2023.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('393e9c5e')) {
      api.createRecord('393e9c5e', component.options)
    } else {
      api.reload('393e9c5e', component.options)
    }
    module.hot.accept("./HomeElections2023.vue?vue&type=template&id=393e9c5e&", function () {
      api.rerender('393e9c5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/home-elections-2023/HomeElections2023.vue"
export default component.exports